module.exports = __webpack_public_path__ + "static/media/close.350be8c1.svg";